import { GOALS_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { StringValue } from '../../../value/types.tsx';
import type { TransformedGoals } from '../types.tsx';

export const getGoalsStringValue = (fieldValue: TransformedGoals['value']) => {
	// we only keep the first goal object in the store (field value)
	const goalsStringValue = fieldValue.goals.map((goal) => goal.name).join(', ');

	const remainingCount = fieldValue.totalCount - fieldValue.goals.length;
	if (remainingCount > 0) {
		return `${goalsStringValue} +${remainingCount}`;
	}
	return goalsStringValue;
};

const getGoalsSelectValue: StringValue<TransformedGoals> = (field) =>
	getGoalsStringValue(field.value);

export const goalStringValueHandler = {
	[GOALS_CF_TYPE]: getGoalsSelectValue,
};
